import { render, staticRenderFns } from "./CustomerStatistics.vue?vue&type=template&id=11416033&scoped=true"
import script from "./CustomerStatistics.vue?vue&type=script&lang=js"
export * from "./CustomerStatistics.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatistics.vue?vue&type=style&index=0&id=11416033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11416033",
  null
  
)

export default component.exports